import React         from 'react';
import ReactDom      from 'react-dom';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from 'contents_modal';
// -------------------------------------------------------

class InfluencerFavorite extends React.Component {
  favorite(is_favorite) {
    Utils.request.bind(this)('/api/influencer/set_favorite', { insta_user_id: this.props.data.insta_user_id, is_favorite: is_favorite },
      function(res){
        this.setState({ data: res.body.data, view: true });
        this.props.refresh_ev.bind(this)();
        
        if( this.props.list_update_ev != undefined ) this.props.list_update_ev.bind(this)('favorite', (is_favorite == true) ? 1 : null);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    if( data.is_guest === true ) return null;
    
    return (
      <div className="influencer-favorite">
        {(data.favorite == null)
          ? <p className="off" onClick={this.favorite.bind(this, true)}><i className="material-icons">star</i><span>お気に入り</span></p>
          : <p className="on" onClick={this.favorite.bind(this, false)}><i className="material-icons">star</i><span>お気に入り</span></p>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerFavorite;